/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskProfileSources } from './RiskProfileSources';
import {
  RiskProfileSourcesFromJSON,
  RiskProfileSourcesFromJSONTyped,
  RiskProfileSourcesToJSON,
} from './RiskProfileSources';
import type { RiskProfileResidualRisk } from './RiskProfileResidualRisk';
import {
  RiskProfileResidualRiskFromJSON,
  RiskProfileResidualRiskFromJSONTyped,
  RiskProfileResidualRiskToJSON,
} from './RiskProfileResidualRisk';

/**
 *
 * @export
 * @interface RiskProfile
 */
export interface RiskProfile {
  /**
   *
   * @type {number}
   * @memberof RiskProfile
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof RiskProfile
   */
  useCase: number;
  /**
   *
   * @type {Array<RiskProfileResidualRisk>}
   * @memberof RiskProfile
   */
  residualRisks: Array<RiskProfileResidualRisk>;
  /**
   *
   * @type {RiskProfileSources}
   * @memberof RiskProfile
   */
  readonly sources: RiskProfileSources;
}

/**
 * Check if a given object implements the RiskProfile interface.
 */
export function instanceOfRiskProfile(value: object): value is RiskProfile {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('residualRisks' in value) || value['residualRisks'] === undefined) return false;
  if (!('sources' in value) || value['sources'] === undefined) return false;
  return true;
}

export function RiskProfileFromJSON(json: any): RiskProfile {
  return RiskProfileFromJSONTyped(json, false);
}

export function RiskProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskProfile {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: json['use_case'],
    residualRisks: (json['residual_risks'] as Array<any>).map(RiskProfileResidualRiskFromJSON),
    sources: RiskProfileSourcesFromJSON(json['sources']),
  };
}

export function RiskProfileToJSON(value?: Omit<RiskProfile, 'id' | 'sources'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: value['useCase'],
    residual_risks: (value['residualRisks'] as Array<any>).map(RiskProfileResidualRiskToJSON),
  };
}
